import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { RouterLink, RouterModule, UrlTree } from '@angular/router';
import { TourAnchorMatMenuDirective } from 'ngx-ui-tour-md-menu';
import { AppIconComponent } from '../icon/app-icon.component';

@Component({
    selector: 'app-nav-item',
    standalone: true,
    imports: [
        RouterModule,
        CommonModule,
        RouterLink,
        MatListModule,
        MatIconModule,
        AppIconComponent,
        MatButtonModule,
        TourAnchorMatMenuDirective
    ],
    templateUrl: './app-nav-item.component.html',
    styleUrl: './app-nav-item.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppNavItemComponent {
    @Input() routerLink!: string | UrlTree | null | undefined;
    @Input() label!: string;
    @Input() icon!: string;
    @Input() activated!: boolean;
    /** When true, active only if the URL matches the link exactly (no child paths). */
    @Input() exact = false;
    @Input() testId = '';
    /**
     * Optional ngx-ui-tour anchor id (shell onboarding).
     * Named `tourAnchorId` so importing TourMatMenu in the parent does not also
     * attach TourAnchorMatMenuDirective to this host (duplicate registration).
     */
    @Input() tourAnchorId: string | null = null;
    @Output() onClick = new EventEmitter();
}
